import { Col, Flex, Row, Skeleton, Tabs } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { textSubmissionDrawerActions, ViewModes } from '../../../../../../../store/slices/text-submission-drawer.slice'
import textSubmissionDrawerSelectors from '../../../../../../../store/selectors/text-submission-drawer.selectors'
import GradingSection from './sections/grading/GradingSection'
import AnswerEditor from './AnswerEditor'
import { getAnswerByQuestion } from '../../../../../../../utils/question.helper'
import NoteInput from './sections/grading/NoteInput'
import { AnswerContextProvider } from './AnswerContext'
import GuidelinesSection from './sections/guidelines/GuidelinesSection'
import HistorySection from './sections/history/HistorySection'
import SimilarAnswersSection from './sections/similar-answers/SimilarAnswersSection'

export const AnswerTabs = {
    GRADING: 'grading',
    INSTRUCTIONS: 'instructions',
    SIMILAR_ANSWERS: 'similarAnswers',
    HISTORY: 'history',
}

const Answer = ({ submissionId, answers, loading, question }) => {
    const dispatch = useDispatch()
    const viewMode = useSelector(textSubmissionDrawerSelectors.viewMode)

    const items = [
        {
            key: AnswerTabs.GRADING,
            label: 'Grading',
            children: <GradingSection submissionId={submissionId} answers={answers} question={question} />,
        },
        {
            key: AnswerTabs.INSTRUCTIONS,
            label: 'Guidelines',
            children: <GuidelinesSection question={question} />,
        },
        {
            key: AnswerTabs.SIMILAR_ANSWERS,
            label: 'Similar answers',
            children: <SimilarAnswersSection question={question} answers={answers} />,
        },
        {
            key: AnswerTabs.HISTORY,
            label: 'History',
            children: <HistorySection question={question} answers={answers} />,
        },
    ]

    const handleClickAnswerArea = () => {
        if (question.children) return
        dispatch(textSubmissionDrawerActions.setFocusedQuestionId(question.id))
    }

    const answer = getAnswerByQuestion(answers, question)

    if (loading) return <Skeleton active />
    return (
        <AnswerContextProvider answers={answers} question={question}>
            <Row gutter={16} onClick={handleClickAnswerArea}>
                {viewMode !== ViewModes.PDF && (
                    <Col span={8}>
                        <Flex vertical gap={8}>
                            <AnswerEditor submissionId={submissionId} answers={answers} question={question} />
                            <NoteInput submissionId={submissionId} answerId={answer.id} note={answer.note} />
                        </Flex>
                    </Col>
                )}
                <Col span={viewMode === ViewModes.PDF ? 24 : 16}>
                    <Tabs
                        onChange={key => dispatch(textSubmissionDrawerActions.setActiveSectionKey(key))}
                        size='small'
                        activeKeys={[AnswerTabs.GRADING]}
                        items={items}
                        rootClassName='section-tabs'
                    />
                </Col>
            </Row>
        </AnswerContextProvider>
    )
}

export default Answer
